import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import "./styles.css";

export default function ThinkingProcess({ steps = [], isThinking = false }) {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(true);
  const scrollRef = useRef(null);

  useEffect(() => {
    if (isThinking) {
      setIsExpanded(true);
    }
  }, [isThinking]);

  useEffect(() => {
    if (!isThinking && steps.length > 0) {
      setIsExpanded(false);
    }
  }, [isThinking, steps.length]);

  useEffect(() => {
    if (scrollRef.current && isExpanded && steps.length > 0) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [steps.length, isExpanded]);

  if (steps.length === 0 && !isThinking) return null;

  return (
    <div className="thinking-process">
      <button
        type="button"
        className={`thinking-toggle ${isExpanded ? "expanded" : ""}`}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <span className="thinking-toggle-arrow">›</span>
        <span className="thinking-icon">✨</span>
        <span className="thinking-label">
          {isThinking
            ? t("thinking.status")
            : t("thinking.process.withSteps", { count: steps.length })}
        </span>
        {isThinking && (
          <div className="thinking-dots">
            <span className="dot" />
            <span className="dot" />
            <span className="dot" />
          </div>
        )}
      </button>

      <div
        className={`thinking-steps-outer ${isExpanded ? "thinking-steps-outer--open" : ""}`}
        aria-hidden={!isExpanded}
      >
        <div className="thinking-steps-outer-inner">
          <div className="thinking-steps-wrapper">
            <div className="thinking-steps-container" ref={scrollRef}>
              {steps.map((step, index) => (
                <div key={index} className="thinking-step">
                  <span className="step-bullet">•</span>
                  <span className="step-text">
                    {step.includes("\n")
                      ? step.split("\n").map((line, i, arr) => (
                          <React.Fragment key={i}>
                            {line}
                            {i < arr.length - 1 && <br />}
                          </React.Fragment>
                        ))
                      : step}
                  </span>
                </div>
              ))}
              {isThinking && steps.length === 0 && (
                <div className="thinking-step">
                  <span className="step-bullet">•</span>
                  <span className="step-text processing">
                    {t("thinking.processing")}
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
